import { getField, updateField } from 'vuex-map-fields';
import StorageService from '@/services/StorageService';
import LessonService from '@/services/LessonService';

const getDefaultState = function () {
    return {
        id: null,
        lessonName: null,
        name: null,
        externalId: null,
        sortOrder: null,
        lessonId: null,
        categoryName: null,
        categoryId: null,
        exerciseTypeId: null,
        status: null,
        subtitle: null
    };
};

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const state = getDefaultState();

const getters = {
    getField,
    form: (state) => ({
        id: state.id,
        lessonName: state.lessonName,
        name: state.name,
        externalId: state.externalId,
        sortOrder: state.sortOrder,
        lessonId: state.lessonId,
        categoryName: state.categoryName,
        categoryId: state.categoryId,
        exerciseTypeId: state.exerciseTypeId,
        status: state.status,
        subtitle: state.subtitle,
    }),
};

const mutations = {
    setExercise(state, value) {
        if (value) {
            // value.Transfers.forEach((status) => {
            //     status.Events.sort((a, b) => new Date(a.Date) - new Date(b.Date));
            // });
            Object.assign(state, value);
        } else {
            Object.assign(state, getDefaultState());
        }
    },

    storeReportDetails(state, data) {
        Object.assign(state, data);
    },
    updateField,
};

const actions = {
    async loadExercise({ commit }, data) {
        const course = StorageService.getCourse();
        const res = await LessonService.getAdminExercises(course.id, {
            EntityId: data.id
        });
        commit('setExercise', res.data.items[0]);
        return res.data;
    },
    async loadExerciseAdmin({ commit }, data) {
        const res = await LessonService.getReportAdmin(data.id);
        commit('setExercise', res.data);
        return res.data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
